import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-page',
	templateUrl:'./WaPagePluginCompPage.html',
	styles: [],
	styleUrls:['./WaPagePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPagePluginCompPage
{
	mdContent_1142 = `\`\`\`java
import com.jwebmp.webawesomepro.WaPage;
\`\`\``;
	mdContent_1143 = `\`\`\`java
new WaPage&lt;&gt;()
\`\`\``;
}
